export default function MarqueeBand() {
    const phrase = "Carvaelis, nous conduisons la confiance.";
    // Repeat the phrase to fill the marquee
    const items = Array.from({ length: 8 });
    return (
        <section
            data-testid="marquee-band"
            aria-label="Slogan Carvaelis"
            className="relative bg-ink text-white overflow-hidden border-y border-white/10 py-8 sm:py-10"
        >
            <div className="flex w-max animate-marquee whitespace-nowrap">
                {items.map((_, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-8 sm:gap-12 px-4 sm:px-6"
                    >
                        <span className="font-display font-black tracking-tighter text-3xl sm:text-5xl lg:text-6xl">
                            {phrase}
                        </span>
                        <span
                            aria-hidden="true"
                            className="text-signal font-display font-black text-3xl sm:text-5xl lg:text-6xl select-none"
                        >
                            ✶
                        </span>
                    </div>
                ))}
            </div>
        </section>
    );
}
